import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';

import {useCookies} from 'react-cookie';
import DotsLoading from '../../../components/dotsLoading';
import InfinitScroll from '../../../components/infinitScroll';
import PrimaryCard from '../../../components/mazraeKit/cards/primaryCard';
import CustomSearchBox from '../../../components/mazraeKit/customSearchBox';
import MainFooter from '../../../components/mazraeKit/footers/footerMain';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';
import NoItemFoundPage from '../../../components/noItemFoundPage';
import {
  useSearchThroughAll,
  useSearchThroughInput,
} from '../../../services/hookService/searchThrough/useSearchThrough';
import {addingFilterInputGuid} from '../../../store/redux/inputGroupAdvertisement';
import useDebounce from '../../../utilities/hooks/useDebounce/useDebounce';
import {CodeToInputGroupName} from '../myFavouriteAdd/card/helper';

const SearchStore = () => {
  const [cookie] = useCookies(['filter_farm']);
  const navigate = useNavigate();
  const {state} = useLocation();
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState<string>(state?.searchValue);
  const debouncedValue = useDebounce(inputValue, 500);
  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };
  const {data, isLoading} = useSearchThroughInput({title: debouncedValue});

  const {
    data: searchThroghAll,
    isLoading: isSearchThroghAllLoading,
    hasNextPage,
    fetchNextPage,
  } = useSearchThroughAll({
    search: debouncedValue,
  });

  useEffect(() => {
    if (cookie?.filter_farm) {
      setInputValue(cookie?.filter_farm?.suggestion?.title || '');
    }
  }, [cookie?.filter_farm]);

  const isSearching = isLoading || isSearchThroghAllLoading;

  return (
    <div className="relative flex flex-col w-full h-full gap-2">
      <CustomHeader
        title="جستجو در فروشگاه"
        preIcon=""
        postComponent={() => (
          <i
            className={`icon-nameArrow---Left text-[25px] text-gray-700`}
            onClick={() => navigate(-1)}
          />
        )}
      />
      <div className="px-3 ">
        <CustomSearchBox
          placeholder="جستجو در فروشگاه "
          type="text"
          value={inputValue}
          inputCustomClass="!pr-2"
          isFloating={true}
          preIcon="icon-nameSearch"
          onChange={onChangeHandler}
          isAutofcus={true}
          {...{inputValue, setInputValue}}
        />
      </div>

      {isLoading ? (
        <div className="flex items-center justify-center h-full">
          <DotsLoading />
        </div>
      ) : (
        <>
          {data?.sub_input && data?.sub_input.length > 0 && (
            <div className="flex  px-3 flex-col h-[50%] overflow-y-auto ">
              <div className="flex flex-col h-full">
                {data?.input_group.length > 0 &&
                  data?.input_group.map(item => (
                    <div
                      className="flex items-center gap-2 py-3 border-b"
                      key={item.guid}
                      onClick={() => {
                        navigate(
                          `/advertisement_listing/${
                            CodeToInputGroupName[item.code]
                          }`,
                          {state: {searchText: item.title}},
                        );
                      }}
                    >
                      <i className="text-lg icon-namefertilizer" />
                      <span>{item.title}</span>
                    </div>
                  ))}
                {data?.sub_input?.map((item: ISearchThroughSubInput) => (
                  <div
                    className="flex gap-2 py-3 border-b"
                    key={item?.guid}
                    onClick={() => {
                      dispatch(
                        addingFilterInputGuid([
                          {guid: item?.input?.guid, title: item?.input?.title},
                        ]),
                      );
                      navigate(
                        `/advertisement_listing/${
                          CodeToInputGroupName[item?.input.input_group.code]
                        }`,
                        {state: {searchText: item.title}},
                      );
                    }}
                  >
                    <span>{item?.title}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {!isSearching && !!!searchThroghAll?.pages?.[0]?.count && (
            <NoItemFoundPage />
          )}
          <div className="flex flex-col h-full gap-2 px-3 overflow-y-auto">
            <InfinitScroll
              isloading={isLoading}
              onWatchEnd={() => !isLoading && hasNextPage && fetchNextPage()}
            >
              {searchThroghAll?.pages
                .flatMap(x => x.results)
                .reverse()
                ?.map((item: ISearchThroughAll, index: number) => (
                  <PrimaryCard
                    {...item}
                    key={item?.id}
                    onClick={() =>
                      navigate(
                        `/category-card-detail/${
                          CodeToInputGroupName[item.input_group?.code]
                        }/${item.id}`,
                      )
                    }
                    cardSize="lg"
                  />
                ))}
            </InfinitScroll>
          </div>
        </>
      )}

      <MainFooter />
    </div>
  );
};

export default SearchStore;
